import { useContext } from "react";
import { CustomersContext } from "../../../contexts/customers/customers.context";

const ASSET = {
  _id: "",
  name: "",
  customer_id: "",
  contact_id: "",
  asset_serial: "",
  asset_type: "",
  asset_type_id: "",
  make: "",
  model: "",
  service_tag: "",
  warranty: "",
  warranty_type: "",
  warranty_end_date: "",
  warranty_start_date: "",
};

const CHANGE_HANDLERS = {
  handleChange: () => {},
};

const GetAssetFormProps = ({
  formObject = ASSET,
  changeHandlers = CHANGE_HANDLERS,
}) => {
  const { query, handleSearch, customers } = useContext(CustomersContext);
  const {
    _id,
    id,
    name,
    customer_id,
    customer_business_name,
    contact_id,
    asset_serial,
    asset_type,
    make,
    model,
    service_tag,
    warranty,
    warranty_type,
    warranty_end_date,
    warranty_start_date,
    updated_at,
    created_at,
  } = formObject;
  const { handleChange } = changeHandlers;

  return {
    name: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Name",
        value: name,
        name: "name",
        onChange: handleChange,
        className: "w-96",
      },
    },
    id: {
      type: "link",
      props: {
        "data-id": _id,
        label: "RepairShopr ID",
        text: id,
        value: id,
        name: "id",
        link: `https://techcyclesolutions.repairshopr.com/customer_assets/${id}`,
        className: "w-96",
      },
    },
    customer_id: {
      type: "link",
      props: {
        "data-id": _id,
        label: "RS Customer ID",
        text: customer_id,
        value: customer_id,
        name: "customer_id",
        link: `https://techcyclesolutions.repairshopr.com/customers/${customer_id}`,
        className: "w-96",
      },
    },
    customer_business_name: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Customer Business Name",
        value: customer_business_name,
        name: "customer_business_name",
        onChange: handleChange,
        className: "w-96",
      },
    },
    contact_id: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Contact ID",
        value: contact_id,
        name: "contact_id",
        onChange: handleChange,
        className: "w-96",
      },
    },
    asset_serial: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Asset Serial",
        value: asset_serial,
        name: "asset_serial",
        onChange: handleChange,
        className: "w-96",
      },
    },
    asset_type: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Asset Type",
        value: asset_type,
        name: "asset_type",
        onChange: handleChange,
        className: "w-96",
      },
    },
    make: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Make",
        value: make,
        name: "make",
        onChange: handleChange,
        className: "w-96",
      },
    },
    model: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Model",
        value: model,
        name: "model",
        onChange: handleChange,
        className: "w-96",
      },
    },
    warranty_start_date: {
      type: "date",
      props: {
        "data-id": _id,
        label: "Warranty Start Date",
        value: warranty_start_date,
        name: "warranty_start_date",
        onChange: handleChange,
        className: "w-96",
      },
    },
    warranty_end_date: {
      type: "date",
      props: {
        "data-id": _id,
        label: "Warranty End Date",
        value: warranty_end_date,
        name: "warranty_end_date",
        onChange: handleChange,
        className: "w-96",
      },
    },
    warranty_type: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Warranty Type",
        value: warranty_type,
        name: "warranty_type",
        onChange: handleChange,
        className: "w-96",
      },
    },
    warranty: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Warranty",
        value: warranty,
        name: "warranty",
        onChange: handleChange,
        className: "w-96",
      },
    },
    service_tag: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Service Tag",
        value: service_tag,
        name: "service_tag",
        onChange: handleChange,
        className: "w-96",
      },
    },
    created_at: {
      type: "datetime",
      props: {
        "data-id": _id,
        label: "Created",
        value: created_at,
        name: "created_at",
        onChange: handleChange,
        className: "w-96",
      },
    },
    updated_at: {
      type: "datetime",
      props: {
        "data-id": _id,
        label: "Updated",
        value: updated_at,
        name: "updated_at",
        onChange: handleChange,
        className: "w-96",
      },
    },
  };
};

export default GetAssetFormProps;
